<div class="client_pageBody space_book_page lg:max-w-[500px] space-y-10">
  <div class="flex flex-col items-center space-y-4">
    <div>
      <img src="/silone/silone_yo.png" style="height: 120px" />
    </div>
    <div class="font-bold text-2xl">{{_common.login_tomo}}</div>
    <a
      *ngIf="debug"
      href="twoonecer-uat://booking?inviteCode={{code}}"
      target="_blank"
    >
      <div class="client_button mt-4">{{_common.open_tomo_app}}</div>
    </a>
    <a *ngIf="!debug" href="tomo://booking?inviteCode={{code}}" target="_blank">
      <div class="client_button mt-4">{{_common.open_tomo_app}}</div>
    </a>
  </div>
  <div class="flex flex-col items-center space-y-4">
    <div>{{_common.tomo_app_not_installed}}</div>
    <div>{{_common.download_now}}</div>
    <div class="flex space-x-2">
      <a
        href="https://play.google.com/store/apps/details?id=com.vicysc.tomo.app"
        target="_blank"
      >
        <img src="/img/dl-aos-btn.png" style="height: 50px" />
      </a>
      <a
        href="https://apps.apple.com/ee/app/to-mo-by-21c-jc/id6739194540"
        target="_blank"
      >
        <img src="/img/dl-ios-btn.png" style="height: 50px" />
      </a>
    </div>
  </div>
  <div class="flex flex-col items-center space-y-4">
    <div>{{_common.or_webLogin}}</div>
    <div class="client_button btn_outline mt-2" (click)="login()">
      <!-- <div class="client_button btn_outline mt-2" [routerLink]="[session.path('/invite-detail/'+code)]"> -->
      {{_common.webLogin}}
    </div>
    <!-- {{session.path('/invite-detail/'+code)}} -->
  </div>
</div>
